import { useMutation } from "@tanstack/react-query";
import fetchJSON from "../lib/reactQueryClient";
import { REACT_APP_GATEWAY_URL } from "constants/constants";

export const unblockUser = async (payload) => {
  const endpoint = `${REACT_APP_GATEWAY_URL}/api/v1/operations/common/unblock-user`;

  const options = {
    method: "POST",
    body: payload,
  };

  return await fetchJSON(endpoint, options);
};

export const useUnblockUser = () => {
  return useMutation({
    mutationFn: unblockUser,
  });
};
